import * as types from "./types";
import {
  Case,
  User,
  Category,
  Chat,
  Message,
  Report,
  Tag,
  MessageTemplate,
  ChatUser,
  Role,
  Notification
} from "../../api/classes";
import { Dispatch } from "redux";
import { DubitoSvc } from "../../api";
import messages from "../../pages/messages";
import * as moment from "moment";
import { SendMessageRequest } from "../../api/DubitoAPI";
import { GlobalState } from "..";
import * as _ from "lodash";
import store from "..";
import {
  saveMessages,
  saveChats,
  saveChatUsers,
  getChatUsers
} from "src/auth/auth";
import {
  saveCases,
  saveUsers,
  saveTags,
  saveCategories,
  updateCase
} from "../db";
export function loadCachedCases(cases: Case[]): types.CaseAction {
  return {
    type: types.LOAD_CACHED_CASES,
    cases
  };
}
export function setCases(cases: Case[]): types.CaseAction {
  return {
    type: types.FETCH_CASES,
    cases,
    cacheLoaded: true
  };
}
export function updateCaseLocal(_case: Case) {
  return (dispatch: Dispatch<any>) => {
    const cases = _.cloneDeep(store.getState().cases.list);
    const old = cases.findIndex(i => i.id === _case.id);
    updateCase(_case);
    if (old > -1) {
      cases[old] = _case;
      dispatch(setCases(cases));
    }
  };
}
export function fetchCases() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getCases().then(cases => {
      cases = cases.filter(i => i.folder !== "deleted");
      saveCases(cases);
      dispatch(setCases(cases));
    });
  };
}
export function setCaseUpdateRequired() {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      type: types.SET_CASE_UPDATE_REQUIRED,
      required: true
    });
  };
}
export function fetchUpdatedCases() {
  return (dispatch: Dispatch<any>) => {
    let latestTime = "1971-01-01T00:00:00.000Z";
    if (!store.getState().cases.list) {
      return;
    }
    store.getState().cases.list.map((i: any) => {
      if (moment(i.updated_at).isAfter(latestTime)) {
        latestTime = i.updated_at;
      }
      if (
        i.reports_updated_at &&
        moment(i.reports_updated_at).isAfter(latestTime)
      ) {
        latestTime = i.reports_updated_at;
      }
    });
    DubitoSvc.getCases({ after: latestTime }).then(updatedCases => {
      const allcases = _.cloneDeep(store.getState().cases.list) as Case[];
      updatedCases.map(a => {
        const index = allcases.findIndex(i => i.id === a.id);
        if (index > -1) {
          allcases[index] = a;
        } else {
          allcases.push(a);
        }
      });
      saveCases(updatedCases);
      dispatch(setCases(allcases));
    });
  };
}
export function setUsers(users: User[]): types.CaseAction {
  return {
    type: types.FETCH_USERS,
    users: users
  };
}
export function setNotifications(
  notifications: Notification[]
): types.CaseAction {
  return {
    type: types.FETCH_NOTIFICATIONS,
    notifications
  };
}
export function setMailList(mailList: User[]): types.CaseAction {
  return {
    type: types.FETCH_MAIL_LIST,
    mailList: mailList
  };
}
export function fetchUsers() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getUsers().then(users => {
      saveUsers(users);
      dispatch(setUsers(users));
    });
  };
}
export function fetchNotifications() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getNotifications().then(notifications => {
      dispatch(setNotifications(notifications));
    });
  };
}
export function fetchMailList() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getMailList().then(users => dispatch(setMailList(users)));
  };
}
export function setRoles(roles: Role[]): types.CaseAction {
  return {
    type: types.FETCH_ROLES,
    roles: roles
  };
}
export function fetchRoles() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getRoles().then(roles => dispatch(setRoles(roles)));
  };
}
export function setCategories(categories: Category[]): types.CaseAction {
  return {
    type: types.FETCH_CATEGORIES,
    categories: categories
  };
}
export function setReports(reports: Report[]): types.CaseAction {
  return {
    type: types.FETCH_REPORTS,
    reports: reports
  };
}
export function setTags(tags: Tag[]): types.CaseAction {
  return {
    type: types.FETCH_TAGS,
    tags: tags
  };
}
export function setMessageTemplates(
  messageTemplates: MessageTemplate[]
): types.CaseAction {
  return {
    type: types.FETCH_MESSAGE_TEMPLATES,
    messageTemplates: messageTemplates
  };
}
export function fetchMessageTemplates() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getMessageTemplates().then(templates =>
      dispatch(setMessageTemplates(templates))
    );
  };
}
export function fetchTags() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getTags().then(tags => {
      saveTags(tags);
      dispatch(setTags(tags));
    });
  };
}
export function fetchCategories() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getCategories().then(categories => {
      saveCategories(categories);
      dispatch(setCategories(categories));
    });
  };
}
export function fetchReports() {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getReports().then(reports => dispatch(setReports(reports)));
  };
}

export function bindMessages(caseID: number, messageIds: number[], callback) {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.bindMessages({ case_id: caseID, messageIds: messageIds }).then(
      res => {
        dispatch(bindMessagesAction(messageIds, res.report, caseID));
        callback(messageIds);
      }
    );
  };
}
export function setMessagesRead(sender_id: string) {
  return (dispatch: Dispatch<any>) => {};
}
export function bindMessagesAction(
  messageIds: number[],
  report: number,
  caseId: number
): types.CaseAction {
  return {
    type: types.BIND_MESSAGES,
    messages: messages,
    messageIds: messageIds,
    reportId: report,
    caseId: caseId
  };
}
export function setChats(chats: Chat[]): types.CaseAction {
  saveChats(chats.slice(0, 1000));
  return {
    type: types.FETCH_CHATS,
    chats: chats
  };
}
export function setMessages(messages: Message[]): types.CaseAction {
  saveMessages(messages.slice(0, 250));
  return {
    type: types.FETCH_MESSAGES,
    messages: messages
  };
}
export function fetchChats(cb?) {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getMessages().then(res => {
      const chats = parseChatsFromMessages(res.messages, res.users);
      saveChatUsers(res.users);
      dispatch(setMessages(res.messages));
      dispatch(setChats(chats));
      if (cb) {
        cb();
      }
    });
  };
}
export function parseChatsFromMessages(
  messages: Message[],
  users?: ChatUser[]
): Chat[] {
  if (!users) {
    users = getChatUsers();
  }
  const reduced = messages.reduce((all: { [key: string]: Chat }, m) => {
    const chatID = m.is_reply === 1 ? m.recipient_id : m.sender_id;
    if (!all[chatID]) {
      all[chatID] = { ...m, chatID: chatID, unreads: +!m.is_read };

      if (m.is_reply && users) {
        const user = users.find(i => i.sender_id === m.recipient_id);
        if (user) {
          all[chatID] = {
            ...all[chatID],
            account_name: user.account_name,
            account_picture: user.account_picture
          };
        }
      }
      return all;
    }
    if (all[chatID].is_reply === 1 && m.is_reply === 0) {
      all[chatID] = {
        ...all[chatID],
        //  account_name: m.account_name,
        //  account_picture: m.account_picture,
        chatID: chatID,
        unreads: +!m.is_read
      };
    } else if (all[chatID].is_reply === 0 && m.is_reply === 0) {
      all[chatID] = {
        ...all[chatID],
        chatID: chatID,
        unreads: all[chatID].unreads + +!m.is_read
      };
    }

    return all;
  }, {});
  const chats = Object.keys(reduced)
    .map(i => {
      return reduced[i];
    })
    .sort((a: Chat, b: Chat) => {
      return moment(b.created_at).diff(a.created_at);
    });
  return chats;
}
export function fetchChatsBefore(id) {
  return (dispatch: Dispatch<any>) => {
    DubitoSvc.getMessages({ oldestMessageId: id }).then(res => {
      let allMessages = _.cloneDeep(store.getState().cases.messages);
      allMessages = allMessages.concat(res.messages);
      const chats = parseChatsFromMessages(allMessages);
      dispatch(setMessages(allMessages));
      dispatch(setChats(chats));
    });
  };
}
export function fetchChatsAfter(messages) {
  return (dispatch: Dispatch<any>) => {
    const allMessages = messages.concat(store.getState().cases.messages);
    const chats = parseChatsFromMessages(allMessages);
    dispatch(setMessages(allMessages));
    dispatch(setChats(chats));
  };
}
export function markAsRead(sender_id) {
  return (dispatch: Dispatch<any>) => {
    const allMessages = store.getState().cases.messages;
    // allMessages.s
    const upAllMessages = allMessages.map(mes => {
      if (mes.sender_id === sender_id) {
        mes.is_read = 1;
      }
      return mes;
    });
    const chats = parseChatsFromMessages(upAllMessages);
    dispatch(setMessages(upAllMessages));
    dispatch(setChats(chats));
  };
}



// WEBPACK FOOTER //
// ./src/store/cases/actions.ts